import ApiClient from './ApiClient';

class MetaLeadFormsAPI extends ApiClient {
  constructor() {
    super('meta/lead_forms', { accountScoped: true });
  }
}

export default new MetaLeadFormsAPI();
